import { render, staticRenderFns } from "./ScheduleAdd.vue?vue&type=template&id=38b5cd1d"
import script from "./ScheduleAdd.vue?vue&type=script&lang=js"
export * from "./ScheduleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports